export default __webpack_public_path__ + "static/media/img-press-release-instantly-new.068069cc.jpg";